<h2>Loading Spinners</h2>

<p>
  You can enable a wide variety of components to have a spinner overlay, but
  most commonly, you'll be using either a div or a button. It's as easy as
  adding a directive: [showLoadingSpinner]="true".
</p>

<p>Here are some examples:</p>

<div style="display: flex">
  <div style="flex: 1">
    <p>
      <button [showLoadingSpinner]="true">I'm a button!</button>
    </p>

    <p>
      <input type="button" value="I'm a button!" [showLoadingSpinner]="true" />
    </p>

    <p>
      <input type="text" value="I'm some text!" [showLoadingSpinner]="true" />
    </p>

    <div style="width: 80%">
      <div
        [showLoadingSpinner]="true"
        style="background-color: #6699aa; border: #666666; padding: 10px"
      >
        I'm a div!
      </div>
    </div>

    <p>
      The spinner is centered horizontally at 100% width, so if you want your
      div with a spinner to be less than 100% of its parent width, you must
      specify that constraint on an outer div, as is demonstrated here.
      Otherwise, the spinner may be offset to the right of center.
    </p>
  </div>
  <div style="flex: 1">
    <textarea codeSnippet>
            <button [showLoadingSpinner]="true">I'm a button!</button>
        </textarea
    >

    <textarea codeSnippet>
            <input type="button" value="I'm a button!" [showLoadingSpinner]="true" />
        </textarea
    >

    <textarea codeSnippet>
            <input type="text" value="I'm some text!" [showLoadingSpinner]="true" />
        </textarea
    >

    <textarea codeSnippet>
            <div style="width:80%">
                <div [showLoadingSpinner]="true" style="background-color: #6699aa; border:#666666; padding:10px;">
                    I'm a div!
                </div>
            </div>
        </textarea
    >
  </div>
</div>
